import { render } from "./view_cot.vue?vue&type=template&id=3810e16c&scoped=true"
import script from "./view_cot.vue?vue&type=script&lang=js"
export * from "./view_cot.vue?vue&type=script&lang=js"

import "./view_cot.vue?vue&type=style&index=0&id=3810e16c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3810e16c"]])

export default __exports__